<template>
    <div class="diagram-choose-type">
        <div v-for="tData in diagramType" :key="tData.value" class="diagram-choose-type-item" @click="clickChooseTypeItem(tData)">
            <span class="diagram-choose-t-text">{{tData.text}}</span>
            <span v-show="tData.value == curDiagramChooseTypeData.value" class="diagram-choose-t-icon"><i class="iconfont icon-selected"></i></span>
        </div>
    </div>
</template>

<script>
import { CONST_DIAGRAM_TYPE } from '../../modules/data/base/consts'
export default {
    name: 'DiagramChooseType',
    computed: {
        curDiagramChooseTypeData() {
            return this.$store.state.diagram.curDiagramChooseTypeData;
        }
    },
    data() {
        return {
            diagramType: CONST_DIAGRAM_TYPE
        }
    },
    mounted: function() {

    },
    methods: {
        clickChooseTypeItem(itemData) {
            this.$bus.emit('resetDiagramChooseNumber');
            this.$store.dispatch('diagram/resetDiagramFormData');
            this.$store.state.diagram.showChooseType = false;
            this.$store.state.diagram.curDiagramChooseTypeData = itemData;
            this.$store.state.diagram.formData.d_type = itemData.value;
        }
    }
}
</script>